<template>
  <v-container>
    <div class="login py-12 px-0 px-md-4">
      <div v-if="this.getLoadingPage" class="loading d-flex justify-center align-center">
        <v-progress-circular
          indeterminate
          color="green"
        ></v-progress-circular>
        <br>
        <p>Carregando...</p>
      </div>
      <v-row class="justify-center align-md-center" style="height: 100%">
        <!-- <p>login form</p> -->
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-card
            outlined
            flat
            class="py-2 py-md-8 px-0 px-md-6 round-corner"
            :color="$vuetify.breakpoint.name === 'xs' ? 'transparent' : ''"
          >
            <v-img
              alt="Logo do 1º Curso de Cannabis Medicinal para Reumatologista"
              class="logo-top shrink mr-2"
              contain
              src="@/assets/logo.svg"
              transition="scale-transition"
              max-height="80px"
              position="center center"
            ></v-img>
            <!-- <div class="text-center mt-8 login-txt">
              <h3>Login</h3>
              <p class="mt-2">Use o mesmo email de sua pré-inscrição</p>
            </div> -->
            <div class="">
              <LoginForm />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">

        <v-col cols="12" md="6" lg="4" xl="3" class="text-center">
          <a @click.stop="helpDialog = true" class="font-weight-bold txt2" style="font-size: .8rem;"><span class="underline px-1">Precisa de ajuda?</span></a>
        </v-col>
      </v-row>
      <v-dialog v-model="helpDialog" max-width="400" >
        <v-card class="pa-4 rounded-lg">
          <v-card-title>Suporte</v-card-title>
          <v-card-text>
            Clique no link abaixo para receber suporte via WhatsApp:
            <v-btn
              depressed
              block
              large
              class="btn-primary mt-6"
              href="https://wa.me/+5521920088559"
              target="_blank"
            >Abrir chat</v-btn>
            <v-btn
              depressed
              block
              large
              text
              class="btn-primary--text mt-3"
              @click.stop="helpDialog = false"
            >Voltar ao site</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- --------- LOGIN DIALOG ------------ -->
      <v-dialog v-model="loginDialog" max-width="400" >
        <v-card class="pa-4">
          <v-form @submit.prevent="login()">
            <v-card-title class="headline">Fazer login</v-card-title>

            <v-card-text class="pb-0">
              Faça login com seu email e senha
              <v-container>
                <v-row>
                  <v-text-field label="Email" type="email" prepend-icon="mdi-account-circle" v-model="email" />
                  <v-text-field label="Senha" :type="showPassword ? 'text' : 'password'" prepend-icon="mdi-lock" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" v-model="password" />
                </v-row>
                <v-row>
                  <p>Ainda não possui uma conta? <a @click.prevent="openRegister(), openLogin()" class="font-weight-bold">Registre-se</a></p>
                </v-row>
              </v-container>
            </v-card-text>
            <v-btn block class="primary-button white--text" type="submit">
              Login
            </v-btn>
          </v-form>
          <p class="mb-0 mt-2 text-center"><a @click.prevent="openForgot(), openLogin()">Esqueci minha senha</a></p>
        </v-card>
      </v-dialog>
      <!-- --------- FORGOT DIALOG --------- -->
      <v-dialog v-model="forgotDialog" max-width="400" >
        <v-card>
          <v-form @submit.prevent="retrieve()">
            <v-card-title class="headline">Recuperar Senha</v-card-title>

            <v-card-text class="pb-0">
              Preencha o campo abaixo com seu email e nós lhe enviaremos um link para resetar sua senha.
              <v-container>
                <v-row>
                  <v-text-field label="Email" prepend-icon="mdi-account-circle" v-model="email" />
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn block class="primary-button white--text" type="submit">
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-form>

        </v-card>
      </v-dialog>
      <!-- --------- REGISTER DIALOG --------- -->
      <v-dialog v-model="registerDialog" max-width="80%" >
        <v-card>
          <v-form @submit.prevent="validate()">
            <v-card-title class="headline">Faça seu cadastro</v-card-title>

            <v-card-text class="pb-0">
              Preencha os campos abaixo com seus dados para se cadastrar
              <v-container>
                <v-stepper class="registerStepper" v-model="stepper" vertical>
                  <!-- STEP 1 -->
                    <v-stepper-step
                      :complete="stepper > 1"
                      step="1"
                      class="overline py-4 pa-0 pa-md-6"
                    >
                      Dados pessoais
                    </v-stepper-step>
                    <v-stepper-content step="1" class="px-4 pl-md-6 pr-md-15 mx-0 ml-md-9 mr-md-n9">
                      <v-row>
                        <v-col cols="12" md="5" class="pb-0">
                          <v-text-field
                            outlined
                            type="text"
                            label="Nome"
                            prepend-inner-icon="mdi-account"
                            v-model="name"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            outlined
                            type="text"
                            label="Sobrenome"
                            prepend-inner-icon="mdi-account"
                            v-model="lastname"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-menu
                            outlined
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                outlined
                                v-model="chosenBirthday"
                                label="Data de nascimento"
                                prepend-inner-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :max="maioridade"
                              :show-current="maioridade"
                              locale="pt-br"
                              v-model="chosenBirthday"
                              @change="updateBirthday"
                              @input="menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <small>Sexo:</small>
                          <v-radio-group v-model="sexo" row class="mt-0">
                            <v-radio
                              label="Masculino"
                              value="masculino"
                            ></v-radio>
                            <v-radio
                              label="Feminino"
                              value="feminino"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <!-- <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            outlined
                            type="tel"
                            label="Telefone"
                            prepend-inner-icon="mdi-phone"
                            v-model="tel"
                            v-mask="['(##) ####-####', '(##) #####-####', '+## (##) ####-####', '+## (##) #####-####']"
                          />
                        </v-col> -->
                      </v-row>
                      <v-btn color="red" class="mr-2" text @click.prevent="openRegister(), resetForm()">
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="(name, lastname, chosenBirthday, sexo) ? stepper = 2 : setFeedback(true, 'Preencha os campos acima', 'OK', 'amber', 'black--text')"
                      >
                        Continuar
                      </v-btn>
                    </v-stepper-content>
                  <!-- STEP 2 -->
                    <v-stepper-step
                      :complete="stepper > 2"
                      step="2"
                      class="overline py-4 pa-0 pa-md-6"
                    >
                      Dados profissionais
                    </v-stepper-step>
                    <v-stepper-content step="2" class="px-4 pl-md-6 pr-md-15 mx-0 ml-md-9 mr-md-n9">
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            outlined
                            type="text"
                            label="especialidade"
                            prepend-inner-icon="mdi-briefcase"
                            v-model="especialidade"
                          />
                        </v-col>
                        <v-col cols="12" md="5" class="pb-0">
                          <v-text-field
                            outlined
                            type="text"
                            label="CRM"
                            prepend-inner-icon="mdi-card-account-details"
                            v-model="crm"
                            @keypress="checkCRM"
                            persistent-hint=""
                          />
                        </v-col>
                      </v-row>
                      <v-btn color="primary" text class="mr-2" @click.prevent="stepper = 1">
                        voltar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="(especialidade, crm) ? stepper = 3 : setFeedback(true, 'Preencha os campos acima', 'OK', 'amber', 'black--text')"
                      >
                        Continuar
                      </v-btn>
                    </v-stepper-content>
                  <!-- STEP 3 -->
                    <v-stepper-step
                      step="3"
                      class="py-4 pa-0 pa-md-6"
                    >
                      <span class="overline">Dados de acesso</span>
                      <small>Usados para acessar a plataforma</small>
                    </v-stepper-step>
                    <v-stepper-content step="3" class="px-4 pl-md-6 pr-md-15 mx-0 ml-md-9 mr-md-n9">
                      <v-row>
                        <v-col cols="10" class="pb-0">
                          <v-text-field
                            outlined
                            type="email"
                            label="Email"
                            prepend-inner-icon="mdi-account-circle"
                            v-model="email"
                          />
                        </v-col>
                        <v-col cols="12" md="5" class="pb-0">
                          <v-text-field
                            outlined
                            label="Senha"
                            :rules="[rules.required, rules.min]"
                            hint="Pelo menos 6 caracteres"
                            counter
                            :type="showPassword ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPassword = !showPassword"
                            v-model="password"
                          />
                        </v-col>
                        <v-col cols="12" md="5" class="pb-0">
                          <v-text-field
                            outlined
                            label="Confirme sua senha"
                            :rules="[rules.required, rules.min]"
                            hint="Deve ser igual ao campo 'senha'"
                            counter
                            :type="showConfirmPassword ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-plus"
                            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showConfirmPassword = !showConfirmPassword"
                            v-model="confirmPassword"
                          />
                        </v-col>
                      </v-row>
                      <v-btn color="primary" class="mr-2" text @click.prevent="stepper = 2">
                        Voltar
                      </v-btn>
                      <v-btn
                        color="primary"
                        type="submit"
                      >
                        Finalizar cadastro
                      </v-btn>
                    </v-stepper-content>
                </v-stepper>
              </v-container>
            </v-card-text>
          </v-form>

        </v-card>
      </v-dialog>
      <!-- ------ MODAL FEEDBACK RETRIEVE ------ -->
      <v-dialog v-model="feedbackModal" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Prontinho!</v-card-title>
          <v-card-text>Cheque seu email. Para escolher uma nova senha basta clicar no link que lhe enviamos e seguir as instruções. Obrigado por usar a plataforma <strong>Webmeeting CMF</strong>!</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn block color="primary-button white--text" @click="feedbackModal = false">Entendi</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ------- SNACKBAR FEEDBACK -------- -->
      <v-snackbar v-if="feedback" :color="feedback.color" :class="feedback.textColor" v-model="feedback.show">
        {{feedback.message}}
        <v-btn :class="feedback.textColor" outlined @click="feedback.show = false" v-if="feedback.btnTxt">
          {{feedback.btnTxt}}
        </v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex"
import db from '@/firebase/init'
import firebase from 'firebase'
import moment from 'moment'
import LoginForm from '@/components/auth/LoginForm'

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  data(){
    return{
      // new registerform
      stepper: 1,
      name: null,
      lastname: null,
      birthday: null,
      chosenBirthday: null,
      sexo: null,
      especialidade: null,
      crm: null,
      email: null,
      password: null,
      confirmPassword: null,
      showPassword: false,
      showConfirmPassword: false,
      menu: false,
      maioridade: moment(Date.now() - 569648000000).format('YYYY-MM-DD'),
      radio: 'Sexo',
      video: {},
      sponsors: [],
      patrocinio: [],
      loginDialog: false,
      registerDialog: false,
      forgotDialog: false,
      helpDialog: false,
      feedbackModal: false,
      feedback: {
        show: false,
        message: '',
        btnTxt: '',
        color: '',
        textColor: ''
      },
      // snackbar: false,
      // alert: false,
      error: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
    }
  },
  computed: {
    ...mapGetters(['getLoadingPage', 'getUser'])
  },
  methods: {
    updateBirthday(){
      this.birthday = moment(this.chosenBirthday).format("DD-MM-YYYY");
    },
    setFeedback(show, message, btnTxt, color, textColor){
      this.feedback = {
        show: show,
        message: message,
        btnTxt: btnTxt,
        color: color,
        textColor: textColor
      }
    },
    login(){
      if(this.email && this.password){
        // console.log('login: ' + this.email + ' ' + this.password)
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(cred => {

          // cred.user.getIdTokenResult().then(idTokenResult => {
          //   let isAdmin = idTokenResult.claims.admin
          //   if(isAdmin){
          //     // window.console.log(isAdmin)
          //     this.$router.push ({ name: 'admin'})
          //   } else{
          //     this.$router.push({ name: 'index' })
          //   }
          // })

        })
        .catch(err => {
          this.setFeedback(true, err.message, 'OK', 'red', 'white--text')
          // this.error = true
        })
      } else{
        this.setFeedback(true, 'Todos os campos devem ser preenchidos', 'OK', 'amber', 'black--text')
      }
    },
    retrieve(){
      if(this.email){
        firebase.auth().sendPasswordResetEmail(this.email)
          .then(() => {
            console.log('Email enviado')
            // this.dialog = true
            this.openForgot()
            this.openFeedbackModal()
          })
          .catch(err => {
            // console.log(err.message)
            this.setFeedback(true, err.message, 'OK', 'red', 'white--text')
            // console.log(this.feedback)
          })
      } else {
        // this.snackbar = true
        this.setFeedback(true, 'Todos os campos devem ser preenchidos', 'OK', 'amber', 'black--text')
      }

    },
    resetForm() {
      this.name = null,
      this.lastname = null,
      this.birthday = null,
      this.chosenBirthday = null,
      this.sexo = null,
      this.especialidade = null,
      this.email = null,
      this.password = null,
      this.crm = null
    },
    validate() {
      if(this.name && this.lastname && this.birthday && this.sexo && this.especialidade && this.email && this.password && this.crm){
        if(this.password == this.confirmPassword) {
          console.log('é igual')
          console.log(
          this.name + ", " +
          this.lastname + ", " +
          this.birthday + ", " +
          this.sexo + ", " +
          this.especialidade + ", " +
          this.email + ", " +
          this.password + ", " +
          this.crm
        )
          this.register()
        } else {
          this.setFeedback(true, "Os campos 'Senha' e 'Confirme sua senha' devem ser iguais", 'OK', 'amber', 'black--text')
        }
      } else{
        this.setFeedback(true, 'Todos os campos devem ser preenchidos', 'OK', 'amber', 'black--text')
      }
    },
    register(){
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(cred => {
          console.log('criou usuario')
          // this.$router.push({ name: 'index' })
          db.collection('usuarios').doc(cred.user.uid)
          .set({
            name: this.name,
            lastname: this.lastname,
            fullName: this.name + " " + this.lastname,
            dtNasc: this.birthday,
            sexo: this.sexo,
            especialidade: this.especialidade,
            email: this.email,
            crm: this.crm,
            dtCadastro: moment(Date.now()).format('YYYY-MM-DD'),
            tsCadastro: Date.now()
          }).then(() => {
            console.log('adicionou ao banco')
            this.$router.push('/')
          })
        })
        .catch(err => {
          // console.log('deu erro' + err.message)
          // window.console.log(err)
          this.setFeedback(true, err.message, 'OK', 'red', 'white--text')
          // this.error = true
        })
    },
    openLogin(){
      // console.log('openLogin')
      this.loginDialog = !this.loginDialog
    },
    openRegister(){
      // console.log('openRegister')
      this.registerDialog = !this.registerDialog
    },
    openForgot(){
      // console.log('openForgot')
      this.forgotDialog = !this.forgotDialog
    },
    openFeedbackModal(){
      this.feedbackModal = !this.feedbackModal
    },
    checkCRM(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        // console.log(charCode)
        // this.alert = true
        this.setFeedback(true, 'Este campo só aceita números, . ou -', 'OK', 'amber', 'black--text')
        evt.preventDefault();
      } else {
        // console.log('é numero')
        // console.log(charCode)
        this.setFeedback(false)
        return true
      }
    },
    getVideo(){
      db.collection('videos').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let video = doc.data()
          // console.log(snapshot.data())
          if(video.display){
            this.video = video
            // console.log(video.data.toDate())
            video.sponsors.forEach(sponsor => {
              let spn = 'https://centrofluminense.com.br/webmeeting-img/img/' + sponsor
              this.sponsors.push(spn)
            })
            if(video.patrocinio){
              video.patrocinio.forEach(patrocinador => {
                let spn = 'https://centrofluminense.com.br/webmeeting-img/img/' + patrocinador
                this.patrocinio.push(spn)
              })
            }

            // video.bg =
          } else{
            // console.log('video sem display')
          }

        });
        // console.log(docs.docs)
      });
    }
  },
  beforeMount() {
    let u = this.getUser
    // console.log(u)
    u ? this.$router.push('/') : ''
  },
  mounted() {
    // let count = 0

    // newUsers.forEach(user => {
    //   console.log(user)
    //   db.collection('usuarios')
    //     .doc(user.email)
    //     .set({
    //       email: user.email,
    //       nome: user.nome,
    //       sobrenome: user.sobrenome,
    //       tel: user.tel,
    //       cpf: user.cpf,
    //       crm: user.crm,
    //     })
    //     .then(() => {
    //       count++
    //     })
    // });

    // console.log(count)

    // db.collection('usuarios')
    //   .get()
    //   .then((snapshot) => {
    //     snapshot.forEach((doc) => {
    //         console.log(doc.id, " => ", doc.data());
    //         count++
    //     });
    //     console.log(count)
    //   })
    //   .catch((error) => {
    //       console.log("Error getting documents: ", error);
    //   });


    // this.getVideo()
    // console.log(videos)
  },
  beforeUpdate() {

  }
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.registerStepper {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.login-txt {
  text-transform: uppercase;
  letter-spacing: 2px;

  p {
    font-size: .6rem;
  }
}
.login{
  padding-top: 0;

  .copy-login{
    z-index: 1;
  }
  .video-desc{
    .v-divider{
      max-height: 4px !important;
      height: 4px !important;
      background-color: $primary;
    }
    h2{
      font-size: 3em;
      font-weight: 700;
    }
    a{
      // color: white;
      text-decoration: underline;
    }
  }
  @media only screen and (max-width: 600px){
    .video-desc{
      h2{
        font-size: 2em;
        font-weight: 700;
      }
      a{
        color: white;
        text-decoration: underline;
      }
    }
  }
}
</style>